import React from 'react'
import { Card, Tabs, Tab, Grid, Typography, FormControl, Select, Switch, CardContent, Divider, Button, IconButton, TextField, } from '@material-ui/core';
import { useStyles } from './styles'
import ReactSelect from 'react-select';
import axiosInstance from '../../../environment/axiosInstance'
import {useHistory,withRouter} from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()


function AddHoliday(props:any) {
    const [holidaysData, setHolidaysData] = React.useState<any>([])
    const history = useHistory()
    const holidayRepeatOptions = [
        {
            id:1,
            label:'Monthly'
        },
        {
            id:2,
            label:'Yearly'
        }

    ]
    const holidayStatusOptions = [
        {
            id:true,
            label:'Active'
        },
        {
            id:false,
            label:'InActive'
        },
    ]
    const [data,setData] = React.useState<any>({
        "name": "",
        "date": "",
        "repeat": 1,
        "status": false
    })
    const classes = useStyles()

const onChangeTextfield = (e:any) =>{
    setData((prev:any) =>{
        return{
            ...prev,
            [e.target.name] : e.target.value
        }
    })
}
const onChangeRepeat = (e:any) =>{
    console.log(e.id)
    const value = e.id
    setData((prev:any) =>{
        return{
            ...prev,
            repeat : value
        }
    })
}
const onChangeStatus = (e:any) =>{
    // console.log(e.id)
    const value = e.id
    setData((prev:any) =>{
        return{
            ...prev,
            status : value
        }
    })
}
const AddHolidaysData = async() =>{
    const id = props.departmentId
    await axiosInstance.post(`/departments/${id}/holidays`,data).then((response: any) => {
        setHolidaysData(response.data.Data)
        //  console.log("response",response)
        if(response.status === 201){
            props.handlePopupModal()
            props.fetchHolidays()
            // toast.success(response.data.message, {
            //     position: toast.POSITION.TOP_RIGHT,
            //     style: {
            //         borderRadius: "2px",
            //         border: "1px solid red"
            //     }, autoClose: 1000
            // })
            // history.push(`/departments/${props.departmentId}/holidays`)
        }
        
    }).catch((response: any) => {
        // console.log(response.message)
        toast.error("Please Enter Holiday Name & Date", {
            position: toast.POSITION.TOP_RIGHT,
            style: {
                borderRadius: "2px",
                border: "1px solid red"
            }, autoClose: 1000
        })
    })


}
// console.log('data',data)
    return (
        <div className={classes.mWdth} style={{}}>
            <Grid container spacing={4} style={{ marginTop: "20px" }}>
                <Grid item md={6} sm={6} xs={6}>
                    <Typography className={classes.departmentNameText}>Title</Typography>
                    <div className={classes.addnewCont}>
                        <TextField
                            size="small"
                            fullWidth
                            value={data.name}
                            name="name"
                            variant="outlined"
                            onChange={onChangeTextfield} 
                        //error={!errors.newnumber.isValid}
                        />
                        {/* {
                    !errors.newnumber.isValid &&
                    <p className={classes.errorMessage}>{errors.newnumber.message}</p>
                } */}
                    </div>
                </Grid>
                <Grid item md={6} sm={6} xs={6}>
                    <Typography className={classes.departmentNameText}>Date</Typography>
                    <div className={classes.addnewCont}>
                        <TextField
                            size="small"
                            type="date"
                            name="date"
                            fullWidth
                            variant="outlined"
                            placeholder="Holiday Date"
                            onChange={onChangeTextfield} 
                        // error={!errors.newName.isValid}
                        />
                        {/* {
                    !errors.newName.isValid &&
                    <p className={classes.errorMessage}>{errors.newName.message}</p>
                } */}

                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: "20px" }}>
                <Grid item md={6} sm={6} xs={6}>
                    <Typography className={classes.departmentNameText}>Repeat</Typography>
                    <div className={classes.addnewCont}>
                        <ReactSelect
                            fullWidth
                            displayEmpty
                            name="repeat"
                            options={holidayRepeatOptions}
                            // inputProps={{ "aria-label": "Without label" }}
                            onChange={onChangeRepeat}
                        />
                    </div>

                </Grid>
                <Grid item md={6} sm={6} xs={6}>
                    <Typography className={classes.departmentNameText}>Status</Typography>
                    <div className={classes.addnewCont}>
                        <ReactSelect
                            fullWidth
                            displayEmpty
                            name="status"
                            options={holidayStatusOptions}
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={onChangeStatus}
                        />
                    </div>


                    {/* <Switch
                className={classes.text}
                //checked={selectAlwaysOpen}
                color="primary"
                name="status"
                //onChange={alwaysOpenChange}

            /> */}
                </Grid>
            </Grid>

            <Divider className={classes.divider2} />
            <Grid container spacing={2} >
                <Grid item md={12} sm={12} xs={12}>
                    <div className={classes.bttns}>
                        <Button size="medium"
                            className={classes.SaveButton}
                        onClick={AddHolidaysData}
                        >
                            Add
                        </Button>

                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default withRouter(AddHoliday)